import onboardingApi from './onboardingApi';
import { TourChecklistItem } from './types';

// Fetches the current user's tour checklist (all active tours + their status).
// Throws on failure so the provider can surface a graceful error state.
const getOnboardingChecklist = async (): Promise<TourChecklistItem[]> => {
  try {
    const { data } = await onboardingApi.get('/checklist');
    return data?.data ?? [];
  } catch (error) {
    console.error('[getOnboardingChecklist] Failed:', error);
    throw error;
  }
};

export default getOnboardingChecklist;
